import { CorrelationCalculationType, CorrelationResultType } from "../routes/analyse/korrelation/korrelationTypes";
import { TabData } from "../routes/netzwirtschaft/netzwirtschaftTypes";

export interface uwList {
  umspannwerk: string;
  messstellen: Array<string>;
}

export interface recorder {
  klasse: string;
  hersteller: string;
  beschreibung: string;
  kategorie: string;
}

export interface datenklasse {
  id: number;
  klasse: string;
  hersteller: string;
  beschreibung: string;
  istSporadisch: boolean;
}

export interface messgroesse {
  beschreibung: string;
  feldname: string;
  einheit: string;
  unterkategorie: string | null;
}

export interface kenngroesse {
  id: number;
  klasse: string;
  feldname: string;
  beschreibung: string;
  kurzname: string;
  kategorie: string;
  unterkategorie: string | null;
  einheit: string;
  pqIndex: boolean;
  anomalien: boolean;
  trends: boolean;
  korrelation: boolean;
  pqIndexKategorie: string;
}

export interface firstLastMesswertRes {
  hersteller: string;
  messstelle: string;
}

export interface messstelle {
  name: string;
  breitengrad: number;
  laengengrad: number;
  schaltfeld: string;
  spannungsebene: string;
  stromwandler: string;
  spannungswandler: string;
  umspannwerk: string;
  kommentar: string;
  hatDaten: boolean;
  zugeordnet: boolean;
  jemalsZugeordnet: boolean;
}

export interface aktiverMesspunkt {
  name: string;
  schaltfeld: string;
  umspannwerk?: string;
  messgeraet: number;
  router?: number;
}

export interface messgeraet {
  id: number;
  seriennummer: string;
  herstellungsjahr: number;
  firmware: string;
  macadresse: string | null;
  kommentar: string | null;
  inbetriebnahmedatum: string | null;
  wartungsintervall: string | null;
  zeitsynchronisationsart: string | null;
  typ: number;
  ipadresse: string | null;
  subnetzmaske: string | null;
  zugeordnet: boolean;
  jemalsZugeordnet: boolean;
}
export interface messgeraettyp {
  id: number;
  typ: string;
  hersteller: string;
  kommentar: string;
  zugeordnet: boolean;
  rauschgrenzeStrom: number;
  rauschgrenzeSpannung: number;
}

export interface routergeraet {
  id: number;
  seriennummer: string;
  herstellungsjahr: number;
  firmware: string;
  macadresse: string | null;
  kommentar: string | null;
  inbetriebnahmedatum: string | null;
  wartungsintervall: string | null;
  zeitsynchronisationsart: string | null;
  typ: number;
  ipadresse: string | null;
  subnetzmaske: string | null;
  zugeordnet: boolean;
  jemalsZugeordnet: boolean;
}
export interface routergeraettyp {
  id: number;
  typ: string;
  hersteller: string;
  kommentar: string;
  zugeordnet: boolean;
}

export interface gruppe {
  id: number;
  name: string;
  typ: number;
}

export interface gruppentyp {
  id: number;
  name: string;
}

export interface gruppenzuordnung {
  gruppeId: number;
  gruppe: string;
  messstelle: string;
  spannungsebene: string;
}

export interface pqstatus {
  beschreibung: string;
  status24h: number;
  status1Month: number;
  status12Month: number;
}

export interface pqstatusgruppe {
  gruppentypId: number;
  gruppentyp: string;
  gruppenId: number;
  gruppenname: string;
  status24h: number;
  status1Month: number;
  status12Month: number;
}

export interface pqstatusmessstelle {
  messstelle: string;
  status24h: number;
  status1Month: number;
  status12Month: number;
}

export interface pqereignissemessstelle {
  zeit: number;
  ende: number;
  messstelle: string;
  typ: string;
  phase: string;
  harmonische: string;
  beschreibung: string;
  zustand: number;
}

export interface betriebsstatus {
  messstelle: string;
  umspannwerk: string;
  schaltfeld: string;
  datenvollstaendigkeit: number;
  kommunikation: number;
}

export interface betriebsereignisDatenvollsteandigkeit {
  messstelle: string;
  beschreibung: string;
  status: number;
  zeit: number;
}

export interface betriebsereignisKommunikation {
  messstelle: string;
  beschreibung: string;
  status: number;
  zeit: number;
}

export interface betriebsereignisListe {
  messstelle: string;
  beschreibung: string;
  status: number;
  zeit: number;
  typ: number;
}

export interface messwertLog {
  id: number;
  triggerZeitpunkt: null | number;
  start: number;
  ende: number;
  messstelle: string;
  datenklasseId: number;
  datenklasse: string;
}

export enum messwertLogGeflaggtStatus {
  offen = "offen",
  verwendet = "verwendet", //falsely flagged. messwerte will be used as is
  verworfen = "verworfen", //rightly flagged. messwerte will be annotated in graph
}

export interface messwertLogGeflaggt {
  id: number;
  regel: string;
  messstelle: string;
  start: number;
  ende: number;
  status: messwertLogGeflaggtStatus;
  kommentar: string;
}

export interface netzereignis {
  id: number;
  ereignisueberschrift: string;
  messstelle: string;
  grund: string;
  freischaltung: Array<string>;
  geplant: boolean;
  zeit: Date;
  ende: Date;
  ereignistext: string;
  kommentar: string;
}

export interface spannungswandler {
  faktor: string;
  kommentar: string;
  zugeordnet: boolean;
}

export interface wandler {
  faktor: string;
  kommentar: string;
  zugeordnet: boolean;
}

export interface stromwandler {
  faktor: string;
  komentar: string;
  zugeordnet: boolean;
}

export interface wartungsintervall {
  name: string;
  kommentar: string;
  zugeordnet: boolean;
}

export interface umspannwerk {
  name: string;
  kuerzel: string;
  breitengrad: number;
  laengengrad: number;
  kommentar: string;
  zugeordnet: boolean;
}

export interface anlage {
  id: number;
  name: string;
  beschreibung: string;
  aktiv: boolean;
  umspannwerk: string;
  anlagentyp: number;
  kommentar: string;
}

export interface anlagentyp {
  id: number;
  typ: string;
  kommentar: string;
}

export interface schaltfeld {
  name: string;
  nummer: string;
  breitengrad: number;
  laengengrad: number;
  umspannwerk: string;
  kommentar: string;
  zugeordnet: boolean;
}

export interface spannungsebene {
  ebene: string;
  kommentar: string;
  zugeordnet: boolean;
  spannungswert: number;
}

export interface zeitsynchronisationsart {
  name: string;
  kommentar: string;
  zugeordnet: boolean;
}

export interface freischaltung {
  id: number;
  name: string;
  kommentar: string;
}

export interface angeschlosseneAnlage {
  id: number;
  name: string;
  beschreibung: string;
  aktiv: boolean;
  umspannwerk: string;
  anlagentyp: number;
  kommentar: string;
}

export interface anlagentyp {
  id: number;
  typ: string;
  kommentar: string;
}

export interface betriebsereignis {
  zeit: number;
  messstelle: string;
  typ: string;
  ende: number;
}

export interface dokument {
  id: number;
  name: string;
  messstelle: string;
  beschreibung: string;
  erstelldatum: Date;
}

export interface konfig {
  id: number;
  kategorie: string;
  name: string;
  wert: string;
  default: boolean;
}

export interface stoerung {
  id: number;
  name: string;
  messstelle: string;
  start: Date;
  ende: Date;
  kommentar: string;
  stoerschriebe: Array<messwertLog>;
  graphen: Array<number>;
  anhaenge: Array<anhang>;
}

export interface datenabruf {
  id: number;
  service: string;
  from: Date;
  to: Date;
  messstellen: Array<string>;
  kenngroessen: Array<string>;
  creationTime: Date;
}

export interface gespeicherteSuche {
  id: number;
  name: string;
  wert: TabData;
  istLoeschbar: boolean;
}

export interface anhang {
  id: number;
  name: string;
  stoerung: number;
}

export interface firstlastTimestampMesswert {
  firstTimeStamp: number;
  lastTimeStamp: number;
}

export interface cellValueObject {
  row: string;
  col: string;
  value: number;
}

export enum AnalysisRequestTyp {
  correlation = "correlationcalculator",
  trends = "trendscalculator",
}

export interface analyseAnfrage {
  id: number;
  name: string;
  start: string;
  ende: string;
  messstellen: Array<string>;
  kenngroessen: Array<string>;
  typ: AnalysisRequestTyp;
  korrelationstyp?: CorrelationCalculationType;
  korrelationsergebnistyp?: CorrelationResultType;
  koeffizientMin?: number;
  koeffizientMax?: number;
  sichtbar: boolean;
  loeschbar: boolean;
}

export interface firewallDokument {
  type: string;
  title: string;
  status: number;
  detail: string;
  instance: string;
  additionalProp1: string;
  additionalProp2: string;
  additionalProp3: string;
}
